module.exports = __webpack_public_path__ + "static/media/social-twitter.23d0a216.svg";